import React, { useState } from 'react';
import styled from 'styled-components';
import Icon from '@mdi/react';
import { mdiChevronDown, mdiChevronRight } from '@mdi/js';

const SectionContainer = styled.div`
  margin-bottom: 20px;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;
  font-size: 11px;
  font-weight: 600;
  color: #5f6368;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8eaed;
  margin-bottom: 10px;
`;

const SectionContent = styled.div<{ $expanded: boolean }>`
  display: ${({ $expanded }) => ($expanded ? 'block' : 'none')};
`;

interface CollapsibleSectionProps {
  title: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  defaultExpanded = true,
  children,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <SectionContainer>
      <SectionHeader onClick={() => setExpanded(!expanded)}>
        <Icon
          path={expanded ? mdiChevronDown : mdiChevronRight}
          size={0.6}
          color="#5f6368"
        />
        {title}
      </SectionHeader>
      <SectionContent $expanded={expanded}>{children}</SectionContent>
    </SectionContainer>
  );
};
